import { ScanLine, Megaphone, ShieldCheck, ArrowRight, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Logo } from '@/components/landing/Logo';

const tiles = [
  {
    to: '/app',
    title: 'Dashboard Hôtesse',
    desc: 'Stats live, scanner QR, validations, profil agent.',
    icon: ScanLine,
    accent: 'from-primary to-primary-glow',
  },
  {
    to: '/partenaire',
    title: 'Dashboard Partenaire',
    desc: 'Campagnes, création, statistiques, leads opt-in.',
    icon: Megaphone,
    accent: 'from-accent to-primary',
  },
  {
    to: '/admin',
    title: 'Dashboard Super Admin',
    desc: 'Utilisateurs, modération, facturation, analytics géo.',
    icon: ShieldCheck,
    accent: 'from-foreground to-foreground/70',
  },
];

const DashboardsHub = () => (
  <div className="bg-hero min-h-screen">
    <header className="mx-auto flex max-w-6xl items-center justify-between px-6 py-6">
      <Logo />
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" /> Retour landing
      </Link>
    </header>
    <main className="mx-auto max-w-6xl px-6 pb-20 pt-10">
      <span className="inline-block rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary">
        Démo
      </span>
      <h1 className="mt-4 font-display text-4xl font-extrabold sm:text-5xl">
        Choisis le dashboard à explorer.
      </h1>
      <p className="mt-3 max-w-2xl text-lg text-muted-foreground">
        Trois rôles, trois interfaces dédiées. Données mockées pour la démo.
      </p>
      <div className="mt-12 grid gap-6 lg:grid-cols-3">
        {tiles.map(t => (
          <Link
            key={t.to}
            to={t.to}
            className="group relative overflow-hidden rounded-3xl border border-border bg-card p-8 shadow-soft transition-all hover:-translate-y-1 hover:shadow-elevated"
          >
            <div
              className={`mb-6 inline-grid size-12 place-items-center rounded-2xl bg-gradient-to-br ${t.accent} text-primary-foreground shadow-cta`}
            >
              <t.icon className="size-5" />
            </div>
            <h3 className="font-display text-xl font-bold">{t.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{t.desc}</p>
            <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
              Ouvrir{' '}
              <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </main>
  </div>
);

export default DashboardsHub;
